import axios from 'axios';

export function getApiBaseUrl() {
  return (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '');
}

export function apiUrl(path) {
  if (!path) return getApiBaseUrl();
  if (/^https?:\/\//i.test(path)) return path;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getApiBaseUrl()}${normalizedPath}`;
}

export function getAuthToken() {
  return localStorage.getItem('token') || '';
}

export function authHeaders(extra = {}) {
  const token = getAuthToken();
  return token ? { ...extra, Authorization: `Token ${token}` } : { ...extra };
}

export function requireAuthHeaders(extra = {}) {
  const token = getAuthToken();
  if (!token) return null;
  return { ...extra, Authorization: `Token ${token}` };
}

export async function apiFetch(path, options = {}) {
  const headers = {
    ...(options.headers || {}),
  };
  return fetch(apiUrl(path), {
    ...options,
    headers,
  });
}

export const api = axios.create({
  baseURL: getApiBaseUrl() || undefined,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Token ${token}`;
    }
  }
  return config;
});

export function apiErrorMessage(error, fallback = 'Request failed.') {
  if (error?.response?.status === 401) {
    return 'Session expired or missing permission. Please sign in again.';
  }
  if (error?.response?.status === 403) {
    return 'You do not have permission to view this data.';
  }
  if (error?.response?.status >= 500) {
    return 'Server error while loading data. Please retry.';
  }
  const data = error?.response?.data;
  if (data?.detail) return data.detail;
  if (data?.error) return data.error;
  if (data?.message) return data.message;
  if (error?.message) return error.message;
  return fallback;
}
